import { SuperUserGuard } from "../../guards/permission.guard";
import { OutpostComponent } from "./outpost.component";
import { OutpostRemoteComponent } from "./remote/outpost-remote.component";
import { Routes } from "@angular/router";

export const OutpostRoutes: Routes = [
  {
    path: "outpost",
    component: OutpostComponent,
    canActivate: [SuperUserGuard],
    children: [
      { path: "remote", component: OutpostRemoteComponent },
      { path: "**", redirectTo: "remote" },
    ],
  },
];
